import {
  ChevronDownIcon,
  MagnifyingGlassIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline"
import React, {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react"

export type Dropdown = {
  id: string
  name: string
}
export type Search = {
  input: string
  userRole: string
  salesRepID: string
}
export type SearchUser = {
  id: string
  firstName: string
  lastName: string
  email: string
}

type Props = {
  isCheck?: boolean
  search?: Search
  isSalesRep?: boolean
  selected?: Dropdown
  setSelected?: Dispatch<SetStateAction<Dropdown>>
  selectedUser?: SearchUser
  setSelectedUser?: Dispatch<SetStateAction<SearchUser | undefined>>
  listingData?: any[]
  listingOfUsers?: any[]
  selectedId?: string[]
  handleSearch?: (input: Search) => void
  populateData?: (id: string, name: string) => void
  handleSelect?: (id: string, name: string) => void
  assign?: { userId: string; salesRepID: string }
  setAssign?: Dispatch<SetStateAction<{ userId: string; salesRepID: string }>>
  firstname?: boolean
}

export const Dropdown: FC<Props> = (props) => {
  const dropdown = useRef<any>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [clickCount, setClickCount] = useState(0)
  const [filteredData, setFilteredData] = useState(props.listingData)
  const [search, setSearch] = useState<{
    id?: string
    name: string
  }>({
    id: "",
    name: "",
  })

  useEffect(() => {
    if (search.name) {
      setFilteredData(
        props.listingData?.filter((item) =>
          item.name.toLowerCase().includes(search.name.toLowerCase()),
        ),
      )
    } else {
      setFilteredData(props.listingData)
    }
  }, [search.name, props.listingData])

  const handleSelect = (item: { id: string; name: string }) => {
    setSearch({ id: item.id, name: "" })
    setFilteredData(props.listingData)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdown.current && !dropdown.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [dropdown, isOpen])

  const toggleDropdown = () => {
    setClickCount((prevClickCount) => prevClickCount + 1)
    setIsOpen(clickCount % 2 === 0)
  }

  const handleSearchChange = (value: string) => {
    setSearch({ name: value })
  }
  const handleSearchUser = (data: string) => {
    const a = { ...props.search }
    a.input = data
    props.handleSearch?.(a as Search)
  }

  return (
    <div className="relative dark:text-primary-1">
      <div>
        <div className="flex justify-between items-center rounded-full text-sm w-full">
          <div
            className="px-2 h-97 bg-white dark:bg-transparent flex items-center justify-between gap-2 w-full border-2 dark:border-secondary-2 rounded "
            onClick={toggleDropdown}
          >
            <span
              className={
                (props.selected && props.selected.id !== "") ||
                  (props.selectedUser && props.selectedUser.id !== "")
                  ? "hidden"
                  : "dark:text-primary-2 text-light-2 px-2"
              }
            >
              {(props.selected && props.selected.id !== "") ||
                (props.selectedUser && props.selectedUser.id !== "")
                ? ""
                : "Select"}
            </span>
            <div className="flex gap-5 tdark:ext-white text-sm rounded-lg ">
              {props.selected && props.selected.id !== "" ? (
                <div className="flex gap-4 justify-between items-center whitespace-nowrap rounded-full w-auto  bg-white  text-sm px-3 py-1 dark:bg-secondary-2 border border-zinc-500/25">
                  <p className="capitalize dark:text-primary-2 text-light-2 text-xs">
                    {props.selected.name}
                  </p>
                  <XCircleIcon
                    className="h-4 w-4 text-primary-3 cursor-pointer"
                    onClick={() => props.setSelected?.({ id: "", name: "" })}
                  />
                </div>
              ) : props.selectedUser && props.selectedUser.id !== "" ? (
                <div className="flex gap-4 justify-between items-center whitespace-nowrap rounded-full dark:bg-secondary-2 border border-zinc-500/25 text-sm px-3 py-1 bg-white">
                  <p className="truncate dark:text-primary-2 text-light-2 text-xs w-auto">
                                        {`${props.selectedUser?.firstName} ${props.selectedUser?.lastName} (${props.selectedUser?.email})`}
                  </p>
                  <XCircleIcon
                    className="h-4 w-4 dark:text-primary-3 text-light-2 cursor-pointer"
                    onClick={() => {
                      props.setSelectedUser?.({
                        id: "",
                        firstName: "",
                        lastName: "",
                        email: "",
                      })
                      if (!props.firstname) {
                        props.populateData?.("", "Select Customer")
                      } else {
                        props.populateData?.("", "")
                      }
                    }}
                  />
                </div>
              ) : null}
            </div>
            <div>
              <ChevronDownIcon className="w-4 h-4 dark:text-primary-2 text-light-2" />
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="mt-0.5 max-h-48 h-48 w-full border-2 dark:border-secondary-2 dark:divide-primary-4/20 dark:bg-primary-1 bg-white text-primary-2 rounded text-sm font-normal focus:outline-none z-10">
          <div className="flex items-center px-2 h-97 border-b dark:border-secondary-2">
            <input
              className="w-full text-sm p-2 dark:bg-primary-1 bg-white outline-none dark:text-white text-light-2"
              type="text"
              placeholder="Search"
              onChange={(e) => {
                if (props.isCheck) {
                  handleSearchUser(e.target.value)
                } else {
                  handleSearchChange(e.target.value)
                }
              }}
            />
            <MagnifyingGlassIcon className="w-4 h-4 dark:text-white text-light-2" />
          </div>
          <div className="max-h-36 overflow-auto divide-y dark:divide-primary-4/40 h-full">
            {props.isCheck
              ? props.listingOfUsers?.map((item, i) => (
                <div
                  key={i}
                  className={
                    (item.id == props.selectedUser?.id
                      ? "bg-white/5 text-primary-3"
                      : "dark:bg-primary-1 bg-white dark:text-primary-2 text-light-2") +
                    " flex gap-3 w-full truncate px-2 py-3 text-xs font-normal capitalize items-center dark:hover:bg-white/5 hover:bg-gray-200 cursor-pointer"
                  }
                  onClick={() => {
                    props.handleSelect?.(item.id, item.firstName)
                    props.setSelectedUser?.({
                      id: item.id,
                      firstName: item.firstName,
                      lastName: item.lastName,
                      email: item.email,
                    })
                    if (props.isSalesRep) {
                      props.handleSearch?.({
                        input: "",
                        userRole: "SALESREP",
                        salesRepID: "",
                      })
                    } else if (!props.isSalesRep) {
                      props.handleSearch?.({
                        input: "",
                        userRole: "CUSTOMER",
                        salesRepID: "",
                      })
                    }
                    if (
                      props.populateData &&
                      props.isCheck &&
                      !props.firstname
                    ) {
                      props.populateData(
                        item.id,
                        `${item.firstName} ${item.lastName}`,
                      )
                    } else if (
                      props.populateData &&
                      props.isCheck &&
                      props.firstname
                    ) {
                      props.populateData(item.id, item.firstName)
                    } else if (props.assign && props.setAssign) {
                      props.setAssign(() => ({
                        userId: props.assign?.userId as string,
                        salesRepID: item.id,
                      }))
                    }
                    setIsOpen(false)
                  }}
                >
                  <div className="flex gap-2">
                    {!props.isSalesRep && (
                        <span className="text-xs font-bold">{item.companyName}</span>
                      )
                    }
                    {props.isCheck
                      ? `| ${item.firstName} ${item.lastName} | (${item.email})`
                      : item.name}
                    
                  </div>
                </div>
              ))
              : filteredData?.map((item, i) => (
                <div
                  key={i}
                  className={
                    (item.id == props.selected?.id
                      ? "bg-white/5 text-primary-3"
                      : "dark:bg-primary-1 bg-white dark:text-primary-2 text-light-2") +
                    " flex gap-3 w-full truncate px-2 py-3 text-xs font-normal capitalize items-center hover:bg-white/5 cursor-pointer"
                  }
                  onClick={() => {
                    props.setSelected?.({ id: item.id, name: item.name })
                    handleSelect(item)
                    setIsOpen(false)
                  }}
                >
                  {props.isCheck
                    ? `${item.firstName} ${item.lastName} (${item.email})`
                    : item.name}
                </div>
              ))}
            {props.listingOfUsers?.length === 0 ? (
              <div className="flex py-2 items-center h-full">
                <span className="text-xs dark:text-primary-2 text-light-2 mx-auto">
                  Not found
                </span>
              </div>
            ) : (
              filteredData?.length === 0 && (
                <div className="flex py-2 items-center h-full">
                  <span className="text-xs dark:text-primary-2 text-light-2 mx-auto">
                    Not found
                  </span>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </div>
  )
}
